module.exports = __webpack_public_path__ + "static/media/S2N11-4.f0b63720.svg";